import RequestAbstract from "../abstract";

export default class PublicTgSessionMessages extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-tg-session-messages";
    }

}
